import { useMemo, useState } from 'react';

import { Button, Grid, Select } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import type { SelectOption } from '@kc-console/common-ui';
import type { ResponseCloudProject } from '@kc-console/context';

interface MegaMenuGlobalSidebarProjectSelectorProps {
  accessibleProjects: ResponseCloudProject[];
}

const MegaMenuGlobalSidebarProjectSelector = ({
  accessibleProjects,
}: MegaMenuGlobalSidebarProjectSelectorProps) => {
  const { t } = useTranslation();
  const [selectedProject, setSelectedProject] = useState('');

  const isSelectedProject = useMemo(() => selectedProject !== '', [selectedProject]);

  const options: SelectOption<string>[] = useMemo(
    () => [
      {
        title: t('layout:mega_menu.header.project_select_option_title'),
        type: 'section',
        items: accessibleProjects?.map(project => {
          const { name, id } = project;
          return {
            text: name || '',
            value: id || '',
          };
        }),
      },
    ],
    [accessibleProjects, t],
  );

  const handleChangeProject = (value: string) => {
    setSelectedProject(value);
  };

  const handleClickMoveProject = () => {
    if (isSelectedProject)
      window.location.href = `${window.location.origin}/dashboard?project_id=${selectedProject}`;
  };

  return (
    <Grid display={'flex'} gap={'8px'} flexDirection={'column'}>
      <Select
        size="lg"
        value={selectedProject}
        options={options}
        placeholder={t('layout:mega_menu.header.project_select_placeholder')}
        onChange={handleChangeProject}
      />
      <Grid>
        <Button
          variant="primary"
          size="lg"
          disabled={!isSelectedProject}
          onClick={handleClickMoveProject}
        >
          {t('layout:mega_menu.header.move_project')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default MegaMenuGlobalSidebarProjectSelector;
